import { render, staticRenderFns } from "./CrmCustomer.vue?vue&type=template&id=30e3e7ea&"
import script from "./CrmCustomer.vue?vue&type=script&lang=js&"
export * from "./CrmCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports